import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import language_45switcher_45global from "/app/middleware/language-switcher.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  language_45switcher_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "client-data": () => import("/app/middleware/client-data.ts")
}